import * as tslib_1 from "tslib";
import * as categoryStoreUpdateOperations from './helpers/categoryStoreUpdateOperations';
import getAllTableViewsContainingItemsForFolder from '../utils/getAllTableViewsContainingItemsForFolder';
import { default as itemsCategoriesStoreUpdate } from 'owa-mail-actions/lib/triage/itemsCategoriesStoreUpdate';
import { getRowKeysFromRowIds, getTableConversationRelation } from 'owa-mail-list-store';
import { selectMailStoreItemById } from 'owa-mail-store';
import { mutator } from 'satcheljs';
/**
 * Mutator which responds to the itemsCategoriesStoreUpdate action message
 */
export default mutator(itemsCategoriesStoreUpdate, function (actionMessage) {
    var itemIds = actionMessage.itemIds, categoriesToAdd = actionMessage.categoriesToAdd, categoriesToRemove = actionMessage.categoriesToRemove, clearCategories = actionMessage.clearCategories;
    itemIds.forEach(function (itemId) {
        var item = selectMailStoreItemById(itemId);
        if (categoriesToAdd) {
            item.Categories = categoryStoreUpdateOperations.addCategoriesToCollection(categoriesToAdd, item.Categories);
            // Unlike conversation level categories update, we only need to rollup the item categories change when it's an add operation.
            // For delete/remove, we skip rolling up on conversations, because we will have to check all other items under that conversation to
            // determine whether to remove/clear them, and that item might not be on the client.
            rollUpAddCategoriesOnConversation(item.ConversationId.Id, item.ParentFolderId.Id, categoriesToAdd);
            return;
        }
        // VSO 23910 - Optimistically item categories store update for remove and clear
        if (categoriesToRemove) {
            item.Categories = categoryStoreUpdateOperations.removeCategoriesFromCollection(categoriesToRemove, item.Categories);
            // newCategoriesCollection is undefined when all categories are removed from the collection
            if (!item.Categories) {
                item.Categories = [];
            }
            return;
        }
        if (clearCategories) {
            item.Categories = [];
            return;
        }
    });
});
/**
 * Roll up the add item category store update on conversations
 * @param conversationId to add categories
 * @param parentFolderId the parent folder id which contains the item
 * @param categoriesToAdd categories to be added to the conversation
 */
function rollUpAddCategoriesOnConversation(conversationId, parentFolderId, categoriesToAdd) {
    var e_1, _a;
    // Roll up category change on conversations which contain this item
    // Need to check all tables for the given folder
    var tableViewsForFolder = getAllTableViewsContainingItemsForFolder(parentFolderId, true /* shouldIncludeSearchTable */);
    var _loop_1 = function (tableView) {
        if (tableView.tableQuery.listViewType == 0 /* Conversation */) {
            var conversationRowKeys = getRowKeysFromRowIds([conversationId], tableView);
            if (conversationRowKeys.length === 0) {
                return "continue";
            }
            conversationRowKeys.forEach(function (conversationRowKey) {
                var tableViewConversationRelation = getTableConversationRelation(conversationRowKey, tableView.id);
                tableViewConversationRelation.categories = categoryStoreUpdateOperations.addCategoriesToCollection(categoriesToAdd, tableViewConversationRelation.categories);
            });
        }
    };
    try {
        for (var tableViewsForFolder_1 = tslib_1.__values(tableViewsForFolder), tableViewsForFolder_1_1 = tableViewsForFolder_1.next(); !tableViewsForFolder_1_1.done; tableViewsForFolder_1_1 = tableViewsForFolder_1.next()) {
            var tableView = tableViewsForFolder_1_1.value;
            _loop_1(tableView);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tableViewsForFolder_1_1 && !tableViewsForFolder_1_1.done && (_a = tableViewsForFolder_1.return)) _a.call(tableViewsForFolder_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
//# sourceMappingURL=itemsCategoriesStoreUpdateMutator.js.map